<template>
  <v-container fluid class="offer-moderation blue lighten-5 pa-0">
    <v-row>
      <v-col cols="12" sm="8" md="9" lg="10" class="pl-5 pl-sm-3 pr-5 pr-sm-5">
        <div class="pa-10 pa-sm-10 pa-md-10 pa-lg-16">
          <v-row justify="center" class="pa-0">
            <v-col cols="10" sm="12" md="10" lg="9">
              <h3 class="offer-moderation__title text-center text-sm-left mb-8">¡Felicitaciones!<br>Estás solo a 1 paso de comenzar a recibir los mejores talentos.</h3>
              <div class="items-seguir">
                <v-row align="center">
                  <v-col cols="12" sm="3" md="2" class="text-center py-2 px-0">
                    <img src="@/assets/images/ico-adjust.webp" />
                  </v-col>
                  <v-col cols="12" sm="9" md="10" class="pa-0">
                    <p>
                      Tu aviso ha pasado en este momento a la etapa de
                      moderación. Con esto buscamos que tu aviso cumpla
                      con buenas prácticas para publicar ofertas laborales,
                      que sea bien comprendido por los candidatos y así,
                      puedas acceder a los mejores talentos para tu organización.
                      Si quieres revisar más detalles respecto a nuestra
                      política de moderación, por favor
                      <a href="https://ikigai-resources.s3.amazonaws.com/assets/others/Pol%C3%ADtica%20de%20Moderaci%C3%B3n%20de%20Ofertas%20Laborales%202020.pdf">ingresa aquí</a>.
                    </p>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="12" sm="3" md="2" class="text-center py-2 px-0">
                    <img src="@/assets/images/ico-24hours.webp" />
                  </v-col>
                  <v-col cols="12" sm="9" md="10" class="pa-0">
                    <p>Dentro de las próximas 24H te avisaremos si debes hacer ajustes o si tu aviso está listo.</p>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="12" sm="3" md="2" class="text-center py-2 px-0">
                    <img src="@/assets/images/ico-payment.webp" />
                  </v-col>
                  <v-col cols="12" sm="9" md="10" class="pa-0">
                    <p>Si aún no has realizado el pago, por favor revisa tu correo con las instrucciones para completarlo.</p>
                  </v-col>
                </v-row>
              </div>
              <div class="main-btn">
                <v-row>
                  <v-col cols="12" class="pa-0 ">
                    <v-row class="pa-0 ma-0 d-flex justify-sm-end justify-center">
                      <v-col cols="11" sm="6" md="5" lg="3">
                        <v-btn
                          to="/organization/home"
                          class="mx-0 my-auto"
                          color="blue"
                          large
                          block
                        >
                          VOLVER
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
};
</script>
